import DynamicChatRoomThread from "%/dynamic-component-editor/standard-pages/chat-room-page/DynamicChatRoomThread.vue";
import ChatroomActions from "%/dynamic-component-editor/standard-pages/chat-room-page/ChatroomActions.vue";
import ListOfChannels from "%/dynamic-component-editor/standard-elements/list-of-channels/ListOfChannels.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyChatRoom extends LegacyEntity {
  get elements() {
    return {
      DynamicChatRoomThread,
      ChatroomActions,
      ListOfChannels,
    };
  }
}
